import { Controller } from 'react-hook-form'
import { format } from 'react-string-format';
import { useTranslation } from 'react-i18next';

const CurrencyInput = (props: any) => {
    const [t] = useTranslation()

    const formatNumber = (num: any) => {
        if (!num) return '';
        return num.replace(/\D/g, '') // Remove non-digit characters
            .replace(/\B(?=(\d{3})+(?!\d))/g, ','); // Add commas every 3 digits
    };

    return (
        <Controller
            control={props.control}
            name={props.name}
            rules={props?.rules}
            render={({ field }) => (
                <div className={`group form-floating w-full relative ${(props.errors) ? ` validation-error` : ``}`}>
                    <input
                        {...props}
                        {...field}
                        dir={props.dir ? props.dir : 'ltr'}
                        className={`form-text transition-all ${(props.unitText ? "pl-11 peer" : "peer")}`}
                        style={{paddingLeft :"40px"}}
                        value={field.value}
                        autoComplete="off"
                        placeholder=""
                        onChange={(event) => {
                            const rawValue = event.target.value.replace(/,/g, ''); // Remove existing commas
                            // setValue('number', rawValue); // Update the form value without commas
                            field.onChange(formatNumber(rawValue)); // Display the formatted value
                        }} />
                    <label htmlFor={props.id} className="peer-focus:text-xs peer-focus:-top-[8px] peer-focus:text-gray-800 dark:peer-focus:text-white peer-placeholder-shown:text-lg peer-placeholder-shown:top-3">
                        <span className="relative">
                            {props.label}
                            {props.rules?.required && <span style={{ color: "#d84b4b" }}>*</span>}
                        </span>
                    </label>
                    {props.unitText && <div className="absolute left-3 top-3.5">{props.unitText}</div>}

                    {props.errors && props.errors.type as any === 'required' &&
                        <div className="text-error text-xs mt-1 hidden group-[.validation-error]:block">{props.errors.message ? props.errors.message : format(t('VALIDATION_ERROR_REQUIRED'), props.label)}</div>}

                    {props.errors && props.errors.type as any === 'min' &&
                        <div className="text-error text-xs mt-1 hidden group-[.validation-error]:block">
                            {props.errors.message ? props.errors.message :
                                (props.rules?.max == undefined || props.rules?.min == props.rules?.max ?
                                    format(t('VALIDATION_ERROR_EXACT_VALUE_LENGTH'), props.label, props.rules?.min)
                                    :
                                    format(t('VALIDATION_ERROR_VALUE_LENGTH'), props.label, props.rules?.min, props.rules?.max))}
                        </div>}

                    {props.errors && props.errors.type as any === 'max' &&
                        <div className="text-error text-xs mt-1 hidden group-[.validation-error]:block">
                            {props.errors.message ? props.errors.message :
                                (props.rules?.min == undefined || props.rules?.min == props.rules?.max ?
                                    format(t('VALIDATION_ERROR_EXACT_VALUE_LENGTH'), props.label, props.rules?.max)
                                    :
                                    format(t('VALIDATION_ERROR_VALUE_LENGTH'), props.label, props.rules?.min, props.rules?.max))}
                        </div>}

                    {props.errors && props.errors.type as any == 'validate' &&
                        <div className="text-error text-xs mt-1 hidden group-[.validation-error]:block">
                            {props.errors.message ? props.errors.message :
                                format(t('VALIDATION_ERROR_INVALID'), props.label)}
                        </div>}
                </div>
            )}
        />
    )
}

export default CurrencyInput;